/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeCircleMOffIcon16Light } from './ShapeCircleMOffIcon16Light';
import { ShapeCircleMOffIcon16Regular } from './ShapeCircleMOffIcon16Regular';
import { ShapeCircleMOffIcon16Solid } from './ShapeCircleMOffIcon16Solid';
import { ShapeCircleMOffIcon20Light } from './ShapeCircleMOffIcon20Light';
import { ShapeCircleMOffIcon20Regular } from './ShapeCircleMOffIcon20Regular';
import { ShapeCircleMOffIcon20Solid } from './ShapeCircleMOffIcon20Solid';
import { ShapeCircleMOffIcon24Regular } from './ShapeCircleMOffIcon24Regular';
import { ShapeCircleMOffIcon24Solid } from './ShapeCircleMOffIcon24Solid';
import { ShapeCircleMOffIcon32Regular } from './ShapeCircleMOffIcon32Regular';
import { ShapeCircleMOffIcon64Regular } from './ShapeCircleMOffIcon64Regular';
var sizes = {
    16: {
        light: ShapeCircleMOffIcon16Light,
        regular: ShapeCircleMOffIcon16Regular,
        solid: ShapeCircleMOffIcon16Solid,
    },
    20: {
        light: ShapeCircleMOffIcon20Light,
        regular: ShapeCircleMOffIcon20Regular,
        solid: ShapeCircleMOffIcon20Solid,
    },
    24: {
        regular: ShapeCircleMOffIcon24Regular,
        solid: ShapeCircleMOffIcon24Solid,
    },
    32: {
        regular: ShapeCircleMOffIcon32Regular,
    },
    64: {
        regular: ShapeCircleMOffIcon64Regular,
    },
};
export var ShapeCircleMOffIcon = forwardRef('ShapeCircleMOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
